/**
 * av-mosaic.js
 * Smooth-scrolls the Mosaic CTA to the first Ascari Variant Selector on the
 * page. The behavior is scoped to Mosaic instances and respects the visitor's
 * reduced-motion preference.
 */
(function () {
  var initialized = new WeakSet();

  function initMosaic(mosaic) {
    if (!mosaic || initialized.has(mosaic)) return;
    initialized.add(mosaic);

    var button = mosaic.querySelector('[data-av-scroll-target]');
    if (!button) return;

    button.addEventListener('click', function (event) {
      var selector = button.dataset.avScrollTarget;
      var target = selector ? document.querySelector(selector) : null;
      if (!target) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.av-mosaic').forEach(initMosaic);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
